import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";
import Button from "../Buttons";
import Textfield from "../Textfield";
import { Validation, getRandomInteger } from "../../helper";
import { useNavigate } from "react-router-dom";
import { SignUpValidation } from "../../helper.js";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import {
  googleAuth,
  userGetCaptcha,
  userSignup,
} from "../../services/userServices";
import { toast } from "react-toastify";
import ToastMessage from "../ToastMessage";
import { Refresh } from "../../assets/images";
import parsePhoneNumberFromString from "libphonenumber-js";
import CustomLoader from "../Loader";
import { TickCheck } from "../../assets/icons";
import { trackFBEvent } from "../../analytics";
import { EVENT } from "../../analytics/constants";
import { signInWithPopup } from "firebase/auth";
import { auth, provider } from "../../firebase";

const SignupForm = () => {
  let navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [guest, setGuest] = useState(false);
  const [termsConditionsChecked, setTermsConditionsChecked] = useState(false);
  const [error, setError] = useState({
    name: "",
    email: "",
    mobileNo: "",
  });
  const [loading, setLoading] = useState(false);
  const [imageLoading, setIsImageLoading] = useState(true);
  const [captchaImage, setCaptchaImage] = useState(true);
  const [showCaptcha, setShowCaptcha] = useState(true);
  const [captchaValue, setCaptchaValue] = useState("");
  const [captchakey, setCaptchaKey] = useState();
  const [countryCode, setCountryCode] = useState("");

  const handleSubmit = (e) => {
    const randomValue = getRandomInteger();
    localStorage.setItem("deviceId", randomValue);
    const phoneNumber = parsePhoneNumberFromString(mobileNo);
    const countruCodeValue = phoneNumber.countryCallingCode;
    const mobileValue = phoneNumber.nationalNumber;
    e.preventDefault();
    let user;
    user = {
      email: email,
      name: name,
      phone: mobileValue,
      captchaKey: captchakey,
      captchaValue: captchaValue,
      countryCode: countruCodeValue,
    };
    const isValid = SignUpValidation(user, setError);
    console.log("user", user);
    if (isValid) {
      handleSignUp(user, randomValue);
    }
  };

  const handleSignUp = async (user, value) => {
    setLoading(true);
    try {
      const response = await userSignup(user, value);
      if (response.status === 201) {
        trackFBEvent(EVENT.SIGN_UP, { userId: response.data.data.userId });
        localStorage.setItem("userID", response.data.data.userId);
        navigate(`/auth/otp?email=${email}`);
      }
    } catch (error) {
      if (navigator.onLine) {
        toast.error(error.message, { hideProgressBar: true });
      } else {
        toast.error(
          <ToastMessage
            message="You're offline now"
            subMessage="Oops! Internet is disconnected."
          />,
          {
            hideProgressBar: true,
          }
        );
      }
    }
    setLoading(false);
  };
  useEffect(() => {
    getCaptcha();
  }, []);

  const resendCaptcha = () => {
    getCaptcha();
  };
  const getCaptcha = async () => {
    setLoading(true);
    try {
      const response = await userGetCaptcha();
      if (response.status === 200) {
        const captchaData = response.data.data;
        setCaptchaImage(captchaData.captcha);
        setShowCaptcha(captchaData.showCaptcha);
        setCaptchaKey(captchaData.value);
      }
    } catch (error) {
      if (navigator.onLine) {
        toast.error(error.message, { hideProgressBar: true });
      } else {
        toast.error(
          <ToastMessage
            message="You're offline now"
            subMessage="Oops! Internet is disconnected."
          />,
          {
            hideProgressBar: true,
          }
        );
      }
    }
    setLoading(false);
  };

  const handleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      let res = await googleAuth({
        idToken: user?.accessToken,
        platform: "web",
      });
      console.log(res?.data);
      localStorage.setItem("token", res?.data?.token);
      localStorage.setItem("refreshToken", res?.data?.refreshToken);
      localStorage.setItem("name", res?.data?.name);
      localStorage.setItem("type", res?.data?.type);
      navigate(`/auth/home`);
    } catch (error) {
      console.error("Error signing in with Google", error);
    }
  };

  return (
    <SignUpForm>
      {loading ? (
        <CustomLoader />
      ) : (
        <>
          <>
            <Textfield
              placeholder={Text.signUpName}
              variant="Name"
              value={name}
              size="large"
              isRounded={true}
              error={!!error.name}
              onChange={(e) => {
                setError((prevState) => {
                  return { ...prevState, name: "" };
                });
                setName(e.target.value);
              }}
              type="text"
              color={Colors.secondaryBlack}
              placeholderColor={Colors.santasGray}
            />
            {error.name && (
              <ErrorMessage field="name">{error.name}</ErrorMessage>
            )}
          </>
          <TextFieldSpace>
            <Textfield
              placeholder={Text.loginEmailPlaceholder}
              variant="Email id"
              value={email}
              size="large"
              isRounded={true}
              error={!!error.email}
              onChange={(e) => {
                setError((prevState) => {
                  return { ...prevState, email: "" };
                });
                setEmail(e.target.value);
              }}
              type="text"
              color={Colors.secondaryBlack}
              placeholderColor={Colors.santasGray}
            />
            {error.email && <ErrorMessage>{error.email}</ErrorMessage>}
          </TextFieldSpace>
          <TextFieldSpace>
            <StyledPhoneInput
              placeholder="Enter phone number"
              onChange={(e) => {
                console.log(e);
                if (e !== undefined) {
                  setMobileNo(e);
                } else {
                  setMobileNo("");
                }
              }}
              defaultCountry="QA"
            />
            {error.email && <ErrorMessage>{error.mobileNo}</ErrorMessage>}
          </TextFieldSpace>
          {imageLoading && <LoadingIndicator />}
          {showCaptcha && (
            <TextFieldSpace>
              {imageLoading && (
                <div className="activity-indicator">Loading...</div>
              )}
              <CaptchaContainer>
                <CaptchaImage
                  alt="Captcha"
                  src={captchaImage}
                  onLoad={() => {
                    setIsImageLoading(false);
                  }}
                />
                <RefreshImage
                  src={Refresh}
                  alt="refresh"
                  onClick={resendCaptcha}
                />
              </CaptchaContainer>

              <TextFieldSpace>
                <Textfield
                  placeholder={Text.EnterCaptcha}
                  value={captchaValue}
                  size="large"
                  isRounded={true}
                  onChange={(e) => {
                    setCaptchaValue(e.target.value);
                  }}
                  type="number"
                  color={Colors.secondaryBlack}
                  placeholderColor={Colors.santasGray}
                />{" "}
                {error.email && (
                  <ErrorMessage>{error.captchaValue}</ErrorMessage>
                )}
              </TextFieldSpace>
            </TextFieldSpace>
          )}
          <TermsContainer>
            {termsConditionsChecked ? (
              <TermsTickContainerChecked
                checked={termsConditionsChecked}
                onClick={() => setTermsConditionsChecked((prev) => !prev)}
              >
                {" "}
              </TermsTickContainerChecked>
            ) : (
              <TermsTickContainer
                checked={termsConditionsChecked}
                onClick={() => setTermsConditionsChecked((prev) => !prev)}
              >
                {" "}
              </TermsTickContainer>
            )}
            <TermsTextContainer>
              I agree to the{" "}
              <TermsLink href="https://qwik.powerholding-intl.com/Content/Pages/terms.html">
                {Text.termsConditions}
              </TermsLink>{" "}
              and{" "}
              <TermsLink href="https://qwik.powerholding-intl.com/Content/Pages/privacy.html">
                {Text.privacy}
              </TermsLink>
            </TermsTextContainer>
          </TermsContainer>
          <AddSpace>
            <Button
              backgroundColor={
                termsConditionsChecked ? Colors.aqua : Colors.aqua
              }
              label="Create Account"
              variant="filled"
              fontColor={termsConditionsChecked ? Colors.white : "#919191"}
              size="large"
              onClick={(e) => {
                handleSubmit(e);
              }}
              disabled={!termsConditionsChecked}
            />
          </AddSpace>
          <Button
                 startIcon={
              <img style={{width:'24px'}}  src={require("../../assets/icons/googleicon.png")} />
            }
            label="Sign Up using Google"
            variant="filled"
            color={Colors.aqua}
            size="large"
            onClick={handleSignIn}
          />
          <div style={{ height: "16px" }}></div>

          <Button
            label="Continue as Guest"
            outlineColor={Colors.aqua}
            size="large"
            borderWidth={"0.2rem"}
            fontColor={Colors.aqua}
            onClick={(e) => {
              // setGuest(!guest);
              // localStorage.setItem("guest", JSON.stringify(!guest));
              navigate("/auth/home");
            }}
          />
          <RegisterText>
            <span>{Text.noAccount}</span>{" "}
            <SignInText onClick={() => navigate("/auth/login")}>
              {Text.signIn}
            </SignInText>
          </RegisterText>
        </>
      )}
    </SignUpForm>
  );
};

export default SignupForm;

const TermsContainer = styled.div`
  padding-top: 20px;
  display: flex;
  gap: 10px;
`;

const TermsTickContainer = styled.div`
  border-radius: 8px;
  border: solid #0a0f81 3px;
  width: 30px;
  height: 20px;
  background-color: ${(props) => (props.checked ? "#0a0f81" : "transparent")};
  @media only screen and (max-width: 768px) {
    font-size: 12px;
    width: 25px;
  }
`;
const TermsTickContainerChecked = styled.div`
  border-radius: 8px;
  border: solid #0a0f81 3px;
  width: 30px;
  height: 20px;
  background-color: ${(props) => (props.checked ? "#0a0f81" : "transparent")};
  background-image: url(${TickCheck});
  @media only screen and (max-width: 768px) {
    font-size: 12px;
    width: 25px;
  }
`;

const TermsTextContainer = styled.div`
  color: ${Colors.black};
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 113.4%;
  @media only screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

const TermsLink = styled.a`
  color: ${Colors.aqua};
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 113.4%;
  text-decoration-line: underline;
  text-decoration-thickness: 0.5px;
  cursor: pointer;
  @media only screen and (max-width: 768px) {
    font-size: 13px;
  }
`;

const SignUpForm = styled.form`
  width: 20rem;
  /* height: 20rem; */
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 768px) {
    height: fit-content;
    border-radius: 0;
    justify-content: space-between;
    display: flex;
    flex-direction: column;
  }
`;
const ErrorMessage = styled.div`
  font-family: "Poppins";
  font-size: 0.75rem;
  color: ${Colors.coralRedApprox};
  position: absolute;
  margin-top: ${(props) => (props.field === "name" ? "3rem" : "0rem")};
`;

const RegisterText = styled.div`
  font-family: "Poppins";
  font-size: 0.875rem;
  text-align: center;
  margin-top: 1rem;

  span:first-child {
    color: ${Colors.black};
  }

  span:last-child {
    color: ${Colors.aqua};
    text-decoration: underline;
  }
`;

const AddSpace = styled.span`
  margin-top: 2.5rem;
  margin-bottom: 1rem;
`;

const TextFieldSpace = styled.span`
  margin-top: 1.2rem;
`;

const StyledPhoneInput = styled(PhoneInput)`
  input {
    border: 1px solid #ccc;
    padding: 0.7rem;
    border-radius: 0.25rem;
    font-family: "Poppins";
    font-size: 0.8125rem;
    line-height: 0.75rem;
    color: ${Colors.secondaryBlack};
  }
`;

const CaptchaImage = styled.img`
  object-fit: contain;
`;
const RefreshImage = styled.img`
  object-fit: contain;
  height: 2rem;
  margin-left: 1rem;
  cursor: pointer;
`;

const CaptchaContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
`;

const LoadingIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  font-size: 16px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
const SignInText = styled.span`
  cursor: pointer;
`;
